import moment from 'moment'
import { useMemo } from 'react'
import Calendar from 'react-calendar'
import { formCalendarTileClassName } from 'app/utils/calendar.utils'

export default function CalendarPicker({
  limitToMonth,
  date,
  allowFutureDates = false,
  allowPastDates = true,
  minDate,
  onDateChange,
}: {
  limitToMonth: boolean
  date?: string
  allowFutureDates?: boolean
  allowPastDates?: boolean
  minDate?: Date
  onDateChange: (date: Date) => void
}) {
  // Parse date string as local time (not UTC) to avoid off-by-one day issues
  const dateObj = useMemo(() => (date ? moment(date).toDate() : undefined), [date])
  return (
    <Calendar
      goToRangeStartOnSelect={false}
      defaultView={limitToMonth ? `year` : `month`}
      maxDetail={limitToMonth ? `year` : `month`}
      minDate={minDate ?? (allowPastDates ? undefined : new Date())}
      maxDate={allowFutureDates ? undefined : new Date()}
      className="date-picker"
      tileClassName={formCalendarTileClassName}
      onChange={(date) => {
        if (!(date instanceof Date)) return
        onDateChange(date)
      }}
      value={dateObj}
      selectRange={false}
      calendarType="gregory"
    />
  )
}
